import { render, staticRenderFns } from "./createFuncionario.vue?vue&type=template&id=c63367f8&scoped=true&"
import script from "./createFuncionario.vue?vue&type=script&lang=js&"
export * from "./createFuncionario.vue?vue&type=script&lang=js&"
import style0 from "./createFuncionario.vue?vue&type=style&index=0&id=c63367f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63367f8",
  null
  
)

export default component.exports